import { Texture } from './Texture';

/**
 * String-keyed cache of GPU textures loaded from a scene manifest.
 *
 * Populated by SceneManifestLoader during the textures stage; consulted later
 * when objects in the manifest reference shared textures by reference name
 * (materialOverrides.texture).
 */
export class TextureCache {
  private textureMap = new Map<string, Texture>();

  public addTexture(reference: string, texture: Texture): void {
    this.textureMap.set(reference, texture);
  }

  public getTexture(reference: string): Texture {
    const tex = this.textureMap.get(reference);
    if (!tex) {
      throw new Error(`No texture with reference ${reference} is loaded`);
    }
    return tex;
  }

  public destroy(gl: WebGL2RenderingContext): void {
    for (const texture of this.textureMap.values()) {
      if (texture.glTexture) gl.deleteTexture(texture.glTexture);
    }
    this.textureMap.clear();
  }
}
